import firebase from 'firebase';

const config = {
        apiKey: "AIzaSyCa8MvW8kGmVZRcoTRsX9RdnR4WEjjZXWM",
        authDomain: "parkfast-dev.firebaseapp.com",
        databaseURL: "https://parkfast-dev.firebaseio.com",
        projectId: "parkfast-dev",
        storageBucket: "parkfast-dev.appspot.com",
        messagingSenderId: "210965449682"
};

firebase.initializeApp(config);
const authProp = firebase.auth;
const auth = firebase.auth();
const currentUser = auth.currentUser;

export {
    config,
    auth,
    currentUser,
    authProp
}